import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from 'react-bootstrap';
import { PAYMENT_CHARGE_WALLET } from '../../../../apis'; 
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleChangeDataChargeWalletPage } from '../../../../redux/actions/pages/wallet/charge_wallet';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';
import BackIcon from '../../../../styles/images/back-without-bg.png';


const ChargeWallet = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { token } = useSelector(state => state.user);
    const { amount } = useSelector(state => state.charge_wallet);

    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    

    const callUrlChargeWallet = () => {
        window.open(PAYMENT_CHARGE_WALLET + `?amount=${removeNonNumeric(amount)}&token=${token}`, "_self");
    };

    const handleBtnChargeClick = () => {
        if(parseInt(removeNonNumeric(amount)) >= 10000)
            callUrlChargeWallet();
        else 
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'حداقل مبلغ 10 هزار ریال میباشد!', severity: 'error', vertical: 'top', horizontal: 'center'}));  
    };

    const handelChangeInputs = (event) => {
        const {name, value} = event.target;

        dispatch(handleChangeDataChargeWalletPage(name, addCommas(removeNonNumeric(changeNumberPersianAndArabic(value))) ));
    };

    const handleBackBtn = () => {
        navigate(-1);
    };


    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    return (

        <div id="charge-wallet-page" onClick={closeBottomSheet} >

            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1}><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10}><h4 className="text-center">شارژ کیف پول</h4></Col>
                <Col xs={1}></Col>
            </Row>

            <div className="text-center mt-5 font-size-22 font-weight-300">
                مبلغ مورد نظر جهت شارژ کیف پول را وارد کنید
            </div>

            <Row>
                <Col xs={12} className="mt-5">
                    <div className="input-wrapper" >
                        <label className="label-wrapper ml-3" htmlFor="first" >مبلغ به ریال</label>
                        <input type="text" name="amount" value={amount} onChange={handelChangeInputs} className="custom-input w-100 px-3 custom-vertical-padding" />
                    </div>
                </Col>

                <Col xs={12} className="mt-4">
                    <Button onClick={handleBtnChargeClick} className="w-100 py-3 login-form-button">
                        پرداخت آنلاین
                    </Button>
                </Col>                
            </Row>


        </div>
    );
}

export default ChargeWallet;